export const stateName = 'bundles';